import {useContext, useEffect} from 'react'
import {AuthContext} from '@/context/Auth/AuthContext'

export const Login = () => {
  const {isReady, isAuthenticated, login} = useContext(AuthContext)

  useEffect(() => {
    if (isReady && !isAuthenticated) {
      login()
    }
  }, [isAuthenticated, isReady, login])

  return null
}
